import apiClient from "./client";

export function getAllTasks() {
  return apiClient.get("/tasks").then((res) => res.data);
}

export function getTasksDue() {
  return apiClient.get("/tasks/due").then((res) => res.data);
}

export function getTasksByUser() {
  return apiClient.get("/tasks/user").then((res) => res.data);
}

export function getTaskById(id) {
  return apiClient.get(`/tasks/${encodeURIComponent(id)}`).then((res) => res.data);
}

export function getTasksByAssetId(assetId) {
  return apiClient.get(`/tasks/asset/${assetId}`).then((res) => res.data);
}

export function getTasksByFindingId(findingId) {
  return apiClient.get(`/tasks/finding/${encodeURIComponent(findingId)}`).then((res) => res.data);
}

export async function createTask(taskDto) {
  return apiClient.post("/tasks", taskDto).then((res) => res.data);
}

export function updateTask(taskDto) {
  return apiClient.put(`/tasks/${taskDto.taskId}`, taskDto).then((res) => res.data);
}

export function deleteTask(taskId) {
  return apiClient.delete(`/tasks/${encodeURIComponent(taskId)}`).then((res) => res.data);
}

export function exportTasksToExcel() {
  return apiClient.post("/tasks/export/excel", {}, { responseType: 'blob' });
}

export function resendTaskAssignmentEmail(taskId) {
  return apiClient.post(`/tasks/${encodeURIComponent(taskId)}/resend-email`).then((res) => res.data);
}

//Task Comments
export function getAllTaskComments(id) {
  return apiClient.get(`/tasks/${encodeURIComponent(id)}/comments`).then((res) => res.data);
}

export async function createTaskComment(taskCommentDto) {
  return apiClient.post("/tasks/comments", taskCommentDto).then((res) => res.data);
}

export async function bulkCompleteTasks(taskIds) {
  return apiClient.post("/tasks/bulk-complete", { taskIds }).then((res) => res.data);
}
